import { render, staticRenderFns } from "./RestaurantesComponent.vue?vue&type=template&id=ec70c5f4&scoped=true"
import script from "./RestaurantesComponent.vue?vue&type=script&lang=js"
export * from "./RestaurantesComponent.vue?vue&type=script&lang=js"
import style0 from "./RestaurantesComponent.vue?vue&type=style&index=0&id=ec70c5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec70c5f4",
  null
  
)

export default component.exports